import { SpinnerMonoIndicators as Spinner } from '@clearkit/icons';
import { FC } from 'react';
import { useParams } from 'react-router-dom';

import AuthLayout, { AuthLayoutHeader } from '~/components/layouts/AuthLayout';
import { useCurrentUser } from '~/hooks/account';

import { SignInWithHubspot } from '../shared/SignInWithHubspot';
import useUpgradeAuthFactors from './useUpgradeAuthFactors';

const SignUp: FC = function() {
  const { accountId } = useParams<{ accountId: string }>();
  const { data, isLoading } = useUpgradeAuthFactors(accountId);

  if (isLoading || !data) {
    return (
      <AuthLayout>
        <Spinner className="w-10 h-10 text-blue-500" />
      </AuthLayout>
    );
  }

  let Component: () => JSX.Element;

  if (data.type === 'magic_link') {
    Component = MagicLinkSent;
  } else if (data.type === 'sso') {
    Component = SSORedirectInProgress;
  } else if (data.type === 'hubspot') {
    Component = HubSpotRedirect;
  } else {
    throw new Error('Unsupported auth factor type');
  }

  return (
    <AuthLayout>
      <Component />
    </AuthLayout>
  );
};

function MagicLinkSent() {
  const { data: user, isLoading } = useCurrentUser();

  if (isLoading || !user) {
    return <Spinner className="w-10 h-10 text-blue-500" />;
  }

  return (
    <>
      <AuthLayoutHeader
        className="w-full"
        description={`We've sent an email to ${user.email}. Follow the link in that email to verify your information and switch to this account.`}
        header={
          <div className="w-full font-semibold">
            Additional authentication required
          </div>
        }
      />
    </>
  );
}

function SSORedirectInProgress() {
  return (
    <>
      <AuthLayoutHeader
        className="w-full"
        description="You must sign in via your authentication provider to switch to this account. Redirect in progress."
        header={
          <div className="w-full font-semibold">
            Redirecting to your identity provider
          </div>
        }
      />
      <Spinner className="w-10 h-10 text-blue-500" />
    </>
  );
}

function HubSpotRedirect() {
  return (
    <>
      <AuthLayoutHeader
        className="text-center w-96"
        header={
          <div className="w-full font-normal">
            You must sign in with HubSpot to switch to this account
          </div>
        }
      />
      <SignInWithHubspot />
    </>
  );
}
export default SignUp;
